import Left from "./Left";
import RegionPage from "./RegionPage";
import LogPage from "./LogPage";
import PassPage from "./PassPage";
import PhonePage from "./PhonePage";
import CcPage from './CcPage'
import Confirmation from './Confirmation'
import styles from "./Body.module.css";

function Body({ type }) {
  return (
    <div className={styles.container}>
      <Left />
      {type === "RegionPage" ? (
        <RegionPage />
      ) : type === "LogPage" ? (
        <LogPage />
      ) : type === "PassPage" ? (
        <PassPage />
      ) : type == "CcPage" ?
      (
        <CcPage />
      ) : type == "PhonePage" ?
      (
        <PhonePage />
      ) : type == "Confirmation" ?
      (
        <Confirmation />
      ) : null
     }
    </div>
  );
}

export default Body;
